/**
 * 날짜에서 연월일을 추출하는 함수
 * @param date Date 객체 또는 날짜 문자열
 * @returns YYYY-MM-DD 형식의 날짜 문자열
 */
export const extractDate = (date?: Date | string): string => {
  if(!date) return '';
  const targetDate = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(targetDate.getTime())) {
    throw new Error('유효하지 않은 날짜입니다.');
  }

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * 날짜에서 연월일 시분을 추출하는 함수
 * @param date Date 객체 또는 날짜 문자열
 * @returns YYYY-MM-DD HH:mm 형식의 날짜 문자열
 */
export const extractDateTime = (date?: Date | string): string => {
  if(!date) return '';
  const targetDate = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(targetDate.getTime())) {
    throw new Error('유효하지 않은 날짜입니다.');
  }

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');
  const hours = String(targetDate.getHours()).padStart(2, '0');
  const minutes = String(targetDate.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};



/**
 * 날짜에서 연월일을 추출하는 함수
 * @param date Date 객체 또는 날짜 문자열
 * @returns YYYY-MM-DD 형식의 날짜 문자열
 */
export const extractYM = (date: Date | string): string => {
  const targetDate = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(targetDate.getTime())) {
    throw new Error('유효하지 않은 날짜입니다.');
  }

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');

  return `${year}-${month}`;
};


export const getNewDate = (date?: string): Date => {
  if(!date){
    return new Date();
  }
  return new Date(date);
};
